import { render, staticRenderFns } from "./system-modals.vue?vue&type=template&id=aa33f468&scoped=true&"
import script from "./system-modals.ts?vue&type=script&lang=ts&"
export * from "./system-modals.ts?vue&type=script&lang=ts&"
import style0 from "./system-modals.vue?vue&type=style&index=0&id=aa33f468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa33f468",
  null
  
)

export default component.exports